import { render, staticRenderFns } from "./UITextArea.vue?vue&type=template&id=5f6cea06&"
import script from "./UITextArea.vue?vue&type=script&lang=js&"
export * from "./UITextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports